import { createApi } from '@reduxjs/toolkit/query/react'
import axiosBaseQuery from 'api/axiosBaseQuery'

const bookingApi = createApi({
  reducerPath: 'bookingApi',
  baseQuery: axiosBaseQuery({
    baseUrl: process.env.REACT_APP_BASE_URL ?? ''
  }),
  // No 'PlotList' here: the plot caches belong to `plotApi` and tags never
  // cross createApi instances. Booking mutations refresh them by dispatching
  // `plotApi.util.invalidateTags` (see `refreshPlotsAndReports`), which also
  // refreshes the report caches on the third instance, `reportApi`.
  tagTypes: ['Booking', 'BookingList'],
  endpoints: () => ({})
})

export default bookingApi
